import React, { Fragment } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapLocationDot, faCheck } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';

const LocationLanding = () => (
  <Root>
    <Banner>
      <FontAwesomeIcon icon={faMapLocationDot} />
    </Banner>
      <TrueImpactText variant='heading-page'>Location</TrueImpactText>
    <Content>
      <HeadlineText>
        Let’s define where the program is operating, so donors can report on the investments and impact they are making on their geographic
        priorities.
      </HeadlineText>
      <ListWrapper>
        <Title>
          What you’ll need
        </Title>
        <Step>
          <FontAwesomeIcon icon={faCheck} />&nbsp;Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        </Step>
        <Step>
          <FontAwesomeIcon icon={faCheck} />&nbsp;Etiam ut nisi nisl.
        </Step>
        <Step>
          <FontAwesomeIcon icon={faCheck} />&nbsp;Nam sit amet neque nisl.
        </Step>
        <Step>
          <FontAwesomeIcon icon={faCheck} />&nbsp;Quisque et pretium risus, vel tempor sem.
        </Step>
        <Step>
          <FontAwesomeIcon icon={faCheck} />&nbsp;Integer elementum tortor eu ipsum molestie pharetra sed eu nisi.
        </Step>
      </ListWrapper>
    </Content>
  </Root>
);

//Need to import this component instead of duplicating styles
const Root = styled.div`
  width: 100%;
  padding: 0 5%;
  min-height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
  text-align: center;
  > * {
    margin: 0 auto;
  }
  .help-text {
    max-width: 540px;
    margin-bottom: ${SPACERS.small};
  }
`;

const Banner = styled.div`
  padding-bottom: ${SPACERS.medium};
  svg {
    height: 80px;
    width: 80px;
  }
`;

const Content = styled.div`
  padding: 20px;
`;

const Text = styled.div`
  font-size: 16px;
  line-height: 28px;
  color: #566778;
`;

const HeadlineText = styled(Text)`
  max-width: 690px;
`;

const Title = styled.div`
  color: #595959;
  font-size: 18px;
  font-weight: bold;
  line-height: 28px;
  margin: 20px 0;
`;

const ListWrapper = styled.div`
  max-width: 540px;
  margin: 0 auto;
`;

const Step = styled(Text)`
  display: flex;
  line-height: 40px;
  align-items: center;
`;

export default LocationLanding;